import { App, Button } from 'antd'
import { Plus } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ResizableDrawer } from 'src/components'

import { ConnectWizard } from './ConnectWizard'
import { useInvalidateMcpAccess } from './hooks'

type Props = {
  workspaceId: number
  isAdmin: boolean
}

export const ConnectDrawer = ({ workspaceId, isAdmin }: Props) => {
  const { t } = useTranslation()
  const { modal } = App.useApp()
  const [open, setOpen] = useState(false)
  // A shown PAT is never displayed again, so closing must not drop it silently.
  const [token, setToken] = useState<string | null>(null)
  const invalidate = useInvalidateMcpAccess(workspaceId)

  // The table behind the drawer shows whatever the client created meanwhile.
  const close = () => {
    setOpen(false)
    setToken(null)
    invalidate()
  }

  const handleClose = () => {
    if (!token) {
      close()

      return
    }
    modal.confirm({
      title: t('workspace.aiConnectors.connect.closeWithTokenTitle'),
      content: t('workspace.aiConnectors.connect.closeWithTokenBody'),
      okText: t('workspace.aiConnectors.connect.closeWithTokenOk'),
      onOk: close
    })
  }

  return (
    <>
      <Button
        type="primary"
        size="small"
        icon={<Plus size={14} />}
        onClick={() => setOpen(true)}
      >
        {t('workspace.aiConnectors.connect.open')}
      </Button>
      <ResizableDrawer
        open={open}
        onClose={handleClose}
        destroyOnHidden
        defaultWidth={720}
        storageKey="workspace-ai-connect-drawer-width"
        title={t('workspace.aiConnectors.connect.title')}
      >
        <ConnectWizard
          workspaceId={workspaceId}
          isAdmin={isAdmin}
          onDone={close}
          token={token}
          onTokenChange={setToken}
        />
      </ResizableDrawer>
    </>
  )
}
